module.exports = __webpack_public_path__ + "static/media/Isis.3bc1e5c2.png";